<script setup lang="ts">
const questions = [
  ['授权码在哪里获得？', '授权码由运营人员核对真实订单后人工下发，不提供自动领取码。'],
  ['激活失败怎么办？', '先核对授权码、系统时间和网络状态。错误会区分无效、禁用、撤销、设备超限和服务不可用。'],
  ['更换设备如何处理？', '在授权额度允许时直接激活；额度已满时联系运营人员核对后解绑旧设备。'],
  ['断网后还能使用吗？', '已激活设备会保存签名凭证，并按授权策略提供有限离线宽限。'],
]
</script>

<template>
  <div class="page-wrap">
    <header class="page-heading">
      <h1>激活帮助</h1>
      <p>授权问题不会要求你提供淘宝密码、Cookie、身份证或原始媒体。</p>
    </header>
    <section class="help-grid">
      <article v-for="([title, detail]) in questions" :key="title" class="ml-card">
        <h2>{{ title }}</h2>
        <p>{{ detail }}</p>
      </article>
    </section>
  </div>
</template>

<style scoped>
.help-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.help-grid article {
  padding: 28px;
}

.help-grid h2 {
  font-size: 18px;
}

.help-grid p {
  color: var(--ml-text-secondary);
  line-height: 1.9;
}

@media (max-width: 720px) {
  .help-grid {
    grid-template-columns: 1fr;
  }
}
</style>
